// src/pages/NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="flex items-center justify-center mt-20 dark:bg-[#0F1824] bg-white">
      <div className="text-center p-10 border rounded-lg shadow-lg bg-white dark:bg-gray-500">
        <h1 className="text-4xl font-bold text-red-500 dark:text-gray-800">404</h1>
        <p className="mt-4 text-xl text-gray-700">صفحه مورد نظر یافت نشد</p>
        <p className="mt-2 dark:text-white text-gray-500">ممکن است لینک اشتباه باشد یا صفحه حذف شده باشد.</p>
        <Link
          to="/ProvincialRegistration"
          className="mt-6 inline-block px-6 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600"
        >
          بازگشت به صفحه اصلی
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
